import { z } from 'zod'

// Vite environment variables validation
const envSchema = z.object({
  // Client-side variables (VITE_ prefix)
  VITE_APP_URL: z.string().optional(),
  VITE_API_URL: z.string().optional(),
  VITE_WORKOS_CLIENT_ID: z.string().optional(),
  VITE_POSTHOG_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.string().optional(),
  NODE_ENV: z.enum(['test', 'development', 'production']).optional(),
  // Server-side variables (no prefix)
  BETTER_STACK_SOURCE_TOKEN: z.string().optional(),
  WORKOS_API_KEY: z.string().optional(),
  DATABASE_URL: z.string().optional(),
  ARCJET_KEY: z.string().optional(),
})

// Parse and validate environment variables
const rawEnv = {
  // Client-side variables
  VITE_APP_URL: import.meta.env.VITE_APP_URL,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WORKOS_CLIENT_ID: import.meta.env.VITE_WORKOS_CLIENT_ID,
  VITE_POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY,
  VITE_POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST,
  NODE_ENV: import.meta.env.NODE_ENV,
  // Server-side variables (from process.env in Node.js contexts)
  BETTER_STACK_SOURCE_TOKEN:
    typeof process !== 'undefined'
      ? process.env.BETTER_STACK_SOURCE_TOKEN
      : undefined,
  WORKOS_API_KEY:
    typeof process !== 'undefined' ? process.env.WORKOS_API_KEY : undefined,
  DATABASE_URL:
    typeof process !== 'undefined' ? process.env.DATABASE_URL : undefined,
  ARCJET_KEY:
    typeof process !== 'undefined' ? process.env.ARCJET_KEY : undefined,
}

export const Env = envSchema.parse(rawEnv)
